import {
  ButtonsDropdownOption,
  Dropdown,
  dropdownTypes,
  NewButtonSize,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { DeleteItemIconButton } from "components/buttons";
import { getTanStackRowProps } from "components/ExcelTable/constants";
import Flex, { GAP_CLASS } from "components/Flex";
import { ALIGN_CLASS } from "components/Flex/Flex";
import { idPropType } from "constants/app";
import useSetDefaultListHandler from "layout/watchwords/hooks/useSetDefaultListHandler";
import { EllipsisIcon } from "lucide-react";
import { string } from "prop-types";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { fetchWatchwordsList } from "slices/watchwords/list/actions";

import useCloneWatchwordsListHandler from "../../hooks/useCloneWatchwordsListHandler";
import useDeleteWatchwordsListHandler from "../../hooks/useDeleteWatchwordsListHandler";
import useExportToCsvHandler from "../../hooks/useExportToCsvHandler";

const ActionsCell = ({ row }) => {
  const dispatch = useDispatch();

  const { default: isDefault, id, name, lockedByAnotherUser } = row.original;

  const onClickDelete = useDeleteWatchwordsListHandler({ id, name });
  const onClickClone = useCloneWatchwordsListHandler(row.original);
  const onClickExport = useExportToCsvHandler(name, id);
  const onClickSetDefault = useSetDefaultListHandler({
    name,
    id,
    onComplete: () => {
      dispatch(fetchWatchwordsList());
    },
  });

  const onOpenChange = (_, e) => {
    if (e) {
      e.stopPropagation();
    }
  };

  const actionOptions = useMemo(() => {
    const options = [
      { content: "Clone Watchwords List", onClick: onClickClone },
      { content: "Export to CSV", onClick: onClickExport },
    ];
    return !isDefault
      ? options.concat({
          content: "Set as Default",
          onClick: onClickSetDefault,
        })
      : options;
  }, [isDefault]);

  return (
    <Flex
      alignItems={ALIGN_CLASS.center}
      justifyContent="flex-end"
      data-show-on-row-hover
      gap={GAP_CLASS.GAP_200}
      style={{ width: "100%" }}
    >
      <Dropdown
        onOpenChange={onOpenChange}
        type={dropdownTypes.buttons}
        propsObject={{
          closeOnMouseLeave: true,
          disabled: lockedByAnotherUser,
          hideArrowIcon: true,
          leftIcon: <EllipsisIcon size={16} />,
          options: actionOptions.map(({ content, onClick }) => (
            <ButtonsDropdownOption
              content={content}
              disabled={lockedByAnotherUser}
              key={content}
              onClick={onClick}
            />
          )),
          buttonVariant: NewButtonVariant.l2,
          buttonSize: NewButtonSize.sm,
        }}
      />

      <DeleteItemIconButton onClick={onClickDelete} />
    </Flex>
  );
};

ActionsCell.propTypes = {
  row: getTanStackRowProps({
    id: idPropType.isRequired,
    name: string.isRequired,
  }),
};

export default ActionsCell;
